export const APP_AUTH_FEATURE_NAME = 'appAuth';
